var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.listPages
    ? _c(
        "div",
        { staticClass: "container-pages-list" },
        _vm._l(_vm.isParent, function(valParent) {
          return _c(
            "div",
            { key: valParent.id, staticClass: "menu-row-access-application" },
            [
              _c(
                "b-row",
                { staticClass: "pr-2" },
                [
                  _c("b-col", { staticClass: "d-flex", attrs: { cols: "5" } }, [
                    _c("img", {
                      staticClass: "m__t--5",
                      attrs: {
                        src: valParent.icon_grey,
                        height: "20",
                        width: "20"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "m__l--10" }, [
                      _c("div", { staticClass: "page-name" }, [
                        _vm._v(_vm._s(valParent.name.toUpperCase()))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "page-id" }, [
                        _vm._v(_vm._s(valParent.id))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "border-left", attrs: { cols: "6" } },
                    [
                      _c("div", { staticClass: "page-type" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              valParent.type === "visible"
                                ? "VISIBLE AT MENU"
                                : "MENU TITLE"
                            ) +
                            " "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  valParent.type === "visible"
                    ? _c(
                        "b-col",
                        { attrs: { cols: "1" } },
                        [
                          _vm.type === "privilege"
                            ? _c("j-toggle", {
                                on: {
                                  input: function($event) {
                                    _vm.changeToggle($event, valParent)
                                  }
                                },
                                model: {
                                  value: valParent.active_privilege,
                                  callback: function($$v) {
                                    _vm.$set(valParent, "active_privilege", $$v)
                                  },
                                  expression: "valParent.active_privilege"
                                }
                              })
                            : _c("img", {
                                staticClass: "cursor-pointer",
                                attrs: {
                                  src: require("@/assets/icon/setting.svg"),
                                  width: "23px",
                                  height: "23px"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.openSetting(valParent)
                                  }
                                }
                              })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.getSubPageByParent(valParent.id), function(valChild) {
                return _c(
                  "div",
                  {
                    key: valChild.id,
                    staticClass:
                      "menu-row p__l--50 m__t--10 m__b--10 child-row",
                    staticStyle: { "margin-left": "20px" }
                  },
                  [
                    _c(
                      "b-row",
                      { staticClass: "pr-2" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "d-flex", attrs: { cols: "5" } },
                          [
                            _c("img", {
                              staticClass: "m__t--5",
                              attrs: {
                                src: valChild.icon_grey,
                                height: "16",
                                width: "16"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "m__l--10" }, [
                              _c("div", { staticClass: "page-name" }, [
                                _vm._v(_vm._s(valChild.name.toUpperCase()))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "page-id" }, [
                                _vm._v(_vm._s(valChild.id))
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "border-left", attrs: { cols: "6" } },
                          [
                            _c("div", { staticClass: "page-type" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    valChild.type === "visible"
                                      ? "VISIBLE AT MENU"
                                      : "MENU TITLE"
                                  ) +
                                  " "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { cols: "1" } },
                          [
                            _vm.type === "privilege"
                              ? _c("j-toggle", {
                                  on: {
                                    input: function($event) {
                                      _vm.changeToggle($event, valChild)
                                    }
                                  },
                                  model: {
                                    value: valChild.active_privilege,
                                    callback: function($$v) {
                                      _vm.$set(
                                        valChild,
                                        "active_privilege",
                                        $$v
                                      )
                                    },
                                    expression: "valChild.active_privilege"
                                  }
                                })
                              : _c("img", {
                                  staticClass: "cursor-pointer",
                                  attrs: {
                                    src: require("@/assets/icon/setting.svg"),
                                    width: "23px",
                                    height: "23px"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.openSetting(valChild)
                                    }
                                  }
                                })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        })
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-574ced00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-574ced00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/access/components/jPagesList.vue
// module id = null
// module chunks = 